"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LogManager_1 = require("../Log/LogManager");
const CommonBaseError_1 = require("../Common/CommonBaseError");
const Fudao_1 = require("./Fudao");
class FudaoPassedTimeCounter {
    constructor(fr) {
        this._logger = LogManager_1.logManager.GetLogger("FudaoPassedTimeCounter");
        this._fudaoIdPassedTimerDic = new Map();
        this._fudaoRepo = fr;
    }
    StartCount(fudaoId) {
        if (!fudaoId)
            throw new FudaoFudaoPassedTimeCounterError(`fudaoId should not be empty.`);
        if (this._fudaoIdPassedTimerDic.has(fudaoId)) {
            this._logger.warn(`Fudao=${fudaoId}'s TimeCounter is alread started. No need to start another.`);
            return;
        }
        const fudao = this._fudaoRepo.FudaoOfId(fudaoId);
        if (fudao === Fudao_1.Fudao.INVALID_FUDAO) {
            this._logger.warn(`No Fudao=${fudaoId} in Repository`);
            return;
        }
        const timer = setInterval(async () => {
            const fudao = await this._fudaoRepo.FudaoOfIdAsync(fudaoId);
            await fudao.UpdatePassedTimeAsync(1000);
        }, 1000);
        this._fudaoIdPassedTimerDic.set(fudaoId, timer);
    }
    EndCount(fudaoId) {
        if (!this._fudaoIdPassedTimerDic.has(fudaoId))
            return;
        const timer = this._fudaoIdPassedTimerDic.get(fudaoId);
        clearInterval(timer);
        this._fudaoIdPassedTimerDic.delete(fudaoId);
    }
    HasCounter(fudaoId) {
        return this._fudaoIdPassedTimerDic.has(fudaoId);
    }
    CountOfCounter() {
        return this._fudaoIdPassedTimerDic.size;
    }
}
exports.FudaoPassedTimeCounter = FudaoPassedTimeCounter;
exports.FudaoFudaoPassedTimeCounterErrorName = "FudaoFudaoPassedTimeCounterError";
class FudaoFudaoPassedTimeCounterError extends CommonBaseError_1.CommonBaseError {
}
exports.FudaoFudaoPassedTimeCounterError = FudaoFudaoPassedTimeCounterError;
//# sourceMappingURL=FudaoPassedTimeCounter.js.map